import { createAction } from '@reduxjs/toolkit';

import type { AppThunk, CurrentPageState } from '../../types/state.types';

export const setCurrentPage = createAction<{ currentPage: CurrentPageState }>('currentPage/set');

export const CurrentPageThunk = {
  set(currentPage: CurrentPageState): AppThunk {
    return (dispatch) => {
      return dispatch(setCurrentPage({ currentPage }));
    };
  },
};
